import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import EnterpriseIcon, { ErrorFilledIcon, CheckCircleFilledIcon } from '@enterprise-ui/icons';
import classnames from 'classnames';
import React from 'react';
import alertUserOfDeprecatedProps from '../../utils/deprecation.js';

var _excluded = ["as", "children", "className", "data-testid", "type"];
var LayoutNotification = function LayoutNotification(_ref) {
  var As = _ref.as,
    children = _ref.children,
    className = _ref.className,
    dataTestId = _ref['data-testid'],
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'default' : _ref$type,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  alertUserOfDeprecatedProps('LayoutNotification', otherProps);
  if (!React.Fragment) {
    console.error('Hey Canvas User! Layout.Notification requires React.Fragment (React 16+). Please update your version of React or use a polyfill.');
    return null;
  }
  var backgroundFinalClasses = classnames('C-Layout__notificationBackground', _defineProperty({}, "--type-".concat(type), type));
  var finalClasses = classnames('C-Layout__notification', _defineProperty({}, "--type-".concat(type), type), className);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: backgroundFinalClasses,
    "data-testid": dataTestId ? "".concat(dataTestId, "_Background") : null
  }), /*#__PURE__*/React.createElement(As, _extends({
    className: finalClasses
  }, otherProps, {
    "data-testid": dataTestId
  }), type === 'error' && /*#__PURE__*/React.createElement(EnterpriseIcon, {
    className: "C-Layout__notificationIcon",
    icon: ErrorFilledIcon
  }), type === 'success' && /*#__PURE__*/React.createElement(EnterpriseIcon, {
    className: "C-Layout__notificationIcon",
    icon: CheckCircleFilledIcon
  }), children));
};
LayoutNotification.displayName = 'Layout.Notification';
LayoutNotification.defaultProps = {
  as: 'div'
};

export { LayoutNotification as default };
